import { useEffect, useState } from "react";
import { getFormData } from "../../../common/FormUtil";
import { createEnvironment, deleteEnvironment, updateEnvironment } from "../../../repository/RealEstateRepository";
import { getEnvColor, getEnvMarker } from "./";
import { RealEstateMap } from "./RealEstateMap";

const EnvironmentMap = (props) => {
  const [basePoint, setBasePoint] = useState(null);
  const [baseMarker, setBaseMarker] = useState(null);
  const [environmentMarkers, setEnvironmentMarkers] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);

  // base-markers
  useEffect(() => {
    if (basePoint == null) return;
    setBaseMarker({ ...basePoint });
  }, [basePoint]);

  // env-markers
  useEffect(() => {
    if (!props.environments) return;
    setEnvironmentMarkers(props.environments.map(v => ({
      ...v,
      icon: getEnvMarker(v),
      onClick: (e) => {
        setSelectedMarker({
          dataset: e.overlay.dataset
        });
      }
    })));
  }, [props.environments]);

  // markers for rendering
  useEffect(() => {
    const markers = [].concat(environmentMarkers);
    if (baseMarker != null) markers.push(baseMarker);
    setMarkers(markers);
  }, [environmentMarkers, baseMarker]);

  return (<>
    <RealEstateMap
      markers={markers}
      onInit={props.onChangeMap}
      onIdle={props.onChangeMap}
      onClick={(e) => setBasePoint({ longitude: e.latlng.x, latitude: e.latlng.y })} />

    <div style={{ position: "absolute", left: 4, top: 56 + 4 }}>
      {selectedMarker == null && (<>
        <EnvironmentCreateForm
          basePoint={basePoint}
          refreshEnvironment={props.refreshEnvironment} />
      </>)}
      {selectedMarker && (<>
        <EnvironmentUpdateForm
          basePoint={basePoint}
          refreshEnvironment={props.refreshEnvironment}
          detail={selectedMarker}
          onClickClose={() => setSelectedMarker(null)}
        />
      </>)}
    </div>
  </>);
};

const EnvironmentCreateForm = (props) => {
  const { basePoint, refreshEnvironment } = props;
  const [selectedType, setSelectedType] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    createEnvironment(formData, () => {
      refreshEnvironment();
      window.Toast.info("Environment Created.");
      e.target.name.value = "";
    });
  };

  const onChangeEducationType = (e) => {
    setSelectedType(e.target.value);
  };

  return (
    <div style={{ width: 240, padding: 10, border: "1px solid #000", background: "#fff" }}>
      <form onSubmit={onSubmit}>
        <select name={"type"} className={"form-control form-control-sm fluid"} style={{ background: getEnvColor(selectedType) }} onChange={onChangeEducationType}>
          <option value={""}>EnvironmentType</option>
          <option value={"DEPARTMENT_STORE"}>백화점</option>
          <option value={"MARKET"}>대형마트</option>
          <option value={"HOSPITAL"}>종합병원</option>
          <option value={"STARBUCKS"}>스타벅스</option>
          <option value={"CUSTOM"}>커스텀</option>
        </select>
        {selectedType && (<>
          <input name={"name"} className="form-control form-control-sm fluid" placeholder={"Name"} />
          <div className="form-group">
            <input name={""} className="form-control form-control-sm fluid text-center" value={[basePoint ? basePoint.latitude : "-", basePoint ? basePoint.longitude : "-"].join(", ")} readOnly />
            <input name={"latitude"} type="hidden" value={basePoint ? basePoint.latitude : ""} readOnly />
            <input name={"longitude"} type="hidden" value={basePoint ? basePoint.longitude : ""} readOnly />
          </div>
          <div>
            <button type={"submit"} className={"btn btn-sm btn-primary"}>Create</button>
          </div>
        </>)}
      </form>
    </div>
  );
};

const EnvironmentUpdateForm = (props) => {
  const detail = props.detail.dataset;
  const [onLoad, setOnLoad] = useState(false);

  useEffect(() => {
    setOnLoad(false);
    setTimeout(() => setOnLoad(true));
  }, [props.detail.dataset]);

  const onClickDelete = (e) => {
    e.preventDefault();
    const answer = window.confirm("Are you sure?");
    if (answer) {
      const formData = getFormData(e.target.form);
      deleteEnvironment(formData, () => {
        window.Toast.warning("Environment Deleted.");
        props.refreshEnvironment();
        props.onClickClose();
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    updateEnvironment(formData, () => {
      window.Toast.info("Environment Updated.");
      props.refreshEnvironment();
    });
  };

  const onClickClose = (e) => {
    e.preventDefault();
    props.onClickClose();
  };

  return (
    <div style={{ width: 240, padding: 10, border: "1px solid #000", background: "#fff" }}>
      {onLoad && (<>
        <form onSubmit={onSubmit}>
          <input name="id" type="hidden" className="fluid" value={detail.id} readOnly />
          <input name="type" className="form-control-plaintext form-control-sm fluid" value={detail.type} readOnly style={{ textIndent: "1em" }} />
          <input name="name" className="form-control form-control-sm fluid" defaultValue={detail.name} />
          <div className="form-group">
            <input name={""} className="form-control form-control-sm fluid" value={[detail.latitude, detail.longitude].join(", ")} readOnly />
            <input name={"latitude"} type="hidden" value={detail.latitude} readOnly />
            <input name={"longitude"} type="hidden" value={detail.longitude} readOnly />
          </div>
          <div>
            <button className={"btn btn-sm btn-danger"} onClick={onClickDelete}>Delete</button>
            &nbsp;<button type={"submit"} className={"btn btn-sm btn-primary"}>Update</button>
            &nbsp;<button className={"btn btn-sm btn-light"} onClick={onClickClose}>Close</button>
          </div>
        </form>
      </>)}
    </div>
  );
};

export { EnvironmentMap };
